import { FC } from "react";
import { PageHeader } from "../../components/PageHeader";
import { ReleasePacks } from "../../modules/ReleasePacks";
import "./style.css";

export const ReleasePacksPage: FC = () => {
  return (
    <div className="release-monitoring-page">
      <PageHeader
        header="Release packs - monitoring"
        description="Select sprint from dropdown to load data about release packs"
      />
      <ReleasePacks />
    </div>
  );
};
